import React, { useEffect } from "react";
import PrimaryCardButton from "../PrimaryCardButton";
import {
  AddIcon,
  BankDetailsIcon,
  BlockCardIcon,
  ChangeCardPinIcon,
  CryptoBuyIcon,
  CryptoDepositIcon,
  CryptoSellIcon,
  CryptoWithdrawIcon,
  HideIcon,
  ShowIcon,
  StatementIcon,
  TopUpIcon,
  TopupListIcon,
  TransferIcon,
  UnblockCardIcon,
} from "../../../Icons";
import BankDetailsModal from "../../../Modals/BankDetailsModal";
import AccountStatementModal from "../../../Modals/AccountStatementModal";
import BlockUnblockCardModal from "../../../Modals/Card/BlockUnblockCardModal";
import { BlockedCard } from "../../../../redux/actions/Cards/BlockedCard";
import { UnblockCard } from "../../../../redux/actions/Cards/UnblockCard";
import ChangePinModal from "../../../Modals/Card/ChangePinModal";
import TopupCardModal from "../../../Modals/Card/ToupCardModal";
import CardStatmentModal from "../../../Modals/Card/CardStatmentModal";
import { useModules } from "../../../../hooks";
import AddAccountModal from "../../../Modals/AddAccount/AddAccountModal";
import { useDispatch, useSelector } from "react-redux";
import { GetFingateCardDetails } from "../../../../redux/actions/Cards/GetCards";
import { setActiveCard } from "../../../../redux/actions/Cards/setActiveCard";
import LoadingSpinner from "../../../Common/LoadingSpinner";

const ButtonCardType = ({ type, activeCard }) => {
  const isBitpaceEnabled = useModules("Bitpace");
  const isCryptoEnabled = useModules("Crypto");
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [hideDetails, setHideDetails] = React.useState(true);
  const [isLoading, setisLoading] = React.useState(false);

  const fetchCardDetails = async () => {
    setisLoading(true);
    try {
      const data = {
        card_id: activeCard.id,
        client_id: activeCard.client_id,
      };
      const getCardDetails = await dispatch(GetFingateCardDetails(data));

      if (getCardDetails.data) {
        let cardDetails = {};

        if (getCardDetails.data.provider === "VM") {
          cardDetails = {
            ...activeCard,
            card_number: getCardDetails.data.card_number_masked,
            card_balance: getCardDetails.data.card_balance,
            hide_details: false,
            is_physical: getCardDetails.data.is_physical,
          };
        } else {
          cardDetails = {
            id: getCardDetails.data.card_id,
            client_id: activeCard.client_id,
            card_number: getCardDetails.data.card_number,
            name: getCardDetails.data.name_on_card,
            card_expiry: getCardDetails.data.card_expiry,
            card_cvv: getCardDetails.data.card_cvv,
            status: getCardDetails.data.card_status,
            currency_code: getCardDetails.data.card_currency_code,
            card_brand: getCardDetails.data.card_brand.toLowerCase(),
            card_provider: getCardDetails.data.provider,
            card_balance: getCardDetails.data.card_balance,
            hide_details: false,
            cType: activeCard.cType,
            is_physical: getCardDetails.data.is_physical,
          };
        }
        dispatch(setActiveCard(cardDetails));
        setHideDetails(false);
      }
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      setisLoading(false);
    }
  };

  const hideCardDetails = () => {
    setHideDetails(true);
    const cardDetails = {
      id: activeCard.id,
      client_id: activeCard.client_id,
      card_number:
        activeCard.card_provider === "VM"
          ? "**** **** **** " + activeCard.card_number.slice(-4)
          : activeCard.card_number.slice(0, 4) +
            " **** **** " +
            activeCard.card_number.slice(-4),
      name: activeCard.name,
      card_expiry: "**/**",
      card_cvv: "***",
      status: activeCard.status,
      currency_code: activeCard.currency_code,
      card_brand: activeCard.card_brand,
      card_provider: activeCard.card_provider,
      card_balance: "******",
      hide_details: true,
      cType: activeCard.cType,
    };
    dispatch(setActiveCard(cardDetails));
  };

  useEffect(() => {
    if (activeCard && activeCard.hide_details === false) {
      setHideDetails(false);
    } else {
      setHideDetails(true);
    }
  }, [activeCard]);

  switch (type) {
    case "account":
      return (
        <>
          {user && !user.is_basic_client && (
            <>
              <PrimaryCardButton
                label="Deposit"
                icon={<AddIcon className={"add-icons"} />}
                link="/deposit"
              />
              {!activeCard?.is_sub_account && (
                <PrimaryCardButton
                  label="Transfer"
                  icon={<TransferIcon className={"h-6 w-6"} />}
                  link="/transfer"
                />
              )}
            </>
          )}
          <BankDetailsModal>
            <PrimaryCardButton
              label="Details"
              icon={<BankDetailsIcon className={"h-6 w-6"} />}
            />
          </BankDetailsModal>
          <AccountStatementModal>
            <PrimaryCardButton
              label="Statement"
              icon={<StatementIcon className={"h-6 w-6"} />}
            />
          </AccountStatementModal>
        </>
      );
    case "crypto":
      return (
        <>
          {isBitpaceEnabled || isCryptoEnabled ? (
            <>
              {isBitpaceEnabled && (
                <PrimaryCardButton
                  label="Deposit"
                  icon={<CryptoDepositIcon className={"h-6 w-6"} />}
                  link="/crypto-deposit"
                />
              )}
              <PrimaryCardButton
                label="Buy"
                icon={<CryptoBuyIcon />}
                link="/crypto-buy"
              />
              <PrimaryCardButton
                label="Sell"
                icon={<CryptoSellIcon />}
                link="/crypto-sell"
              />
              <PrimaryCardButton
                label="Withdraw"
                icon={<CryptoWithdrawIcon className={"h-6 w-6"} />}
                link="/crypto-withdraw"
              />
              <AccountStatementModal type="crypto">
                <PrimaryCardButton
                  label="Statement"
                  icon={<StatementIcon className={"h-6 w-6"} />}
                />
              </AccountStatementModal>
            </>
          ) : (
            <>
              <AddAccountModal crypto={true}>
                <PrimaryCardButton
                  label="Add Crypto"
                  icon={<AddIcon className={"add-icons"} />}
                  // link="/crypto-deposit"
                />
              </AddAccountModal>

              <AccountStatementModal type="crypto">
                <PrimaryCardButton
                  label="Statement"
                  icon={<StatementIcon className={"h-6 w-6"} />}
                />
              </AccountStatementModal>
            </>
          )}
        </>
      );
    case "card":
      const isInstant = activeCard?.cType === "Instant Card";
      const isMMorVM =
        activeCard?.card_provider === "MM" ||
        activeCard?.card_provider === "VM";
      return (
        <>
          {isLoading && <LoadingSpinner className={"h-6 w-6"} />}

          {activeCard.status === "Active" ? (
            <>
              {!hideDetails ? (
                <div onClick={hideCardDetails}>
                  <PrimaryCardButton
                    label="Hide Details"
                    icon={<HideIcon className={"p-1.5"} />}
                  />
                </div>
              ) : (
                <div onClick={fetchCardDetails}>
                  <PrimaryCardButton
                    label="Show Details"
                    icon={<ShowIcon className={"p-1.5"} />}
                  />
                </div>
              )}

              <TopupCardModal activeCard={activeCard}>
                <PrimaryCardButton
                  label="Top-up"
                  icon={<TopUpIcon className={"h-6 w-6"} />}
                />
              </TopupCardModal>

              <BlockUnblockCardModal
                activeCard={activeCard}
                contextlabel="Block card"
                reasonlabel="block"
                reduxAction={BlockedCard}
              >
                <PrimaryCardButton
                  label="Block card"
                  icon={<BlockCardIcon className={"h-6 w-6"} />}
                />
              </BlockUnblockCardModal>

              {isInstant && isMMorVM && (
                <ChangePinModal activeCard={activeCard}>
                  <PrimaryCardButton
                    label="Change Pin"
                    icon={<ChangeCardPinIcon className={"h-6 w-6"} />}
                  />
                </ChangePinModal>
              )}

              <CardStatmentModal activeCard={activeCard}>
                <PrimaryCardButton
                  label="Statement"
                  icon={<StatementIcon className={"h-6 w-6"} />}
                />
              </CardStatmentModal>

              <PrimaryCardButton
                link={"/card-topup"}
                label="Top-up list"
                icon={<TopupListIcon />}
              />
            </>
          ) : (
            <>
              {activeCard.card_provider === "MM" &&
              isInstant &&
              activeCard.status === "Waiting For Activation" ? (
                // MM Instant + Waiting For Activation → ChangePinModal
                <ChangePinModal activeCard={activeCard}>
                  <PrimaryCardButton
                    label="Activate Card"
                    icon={<UnblockCardIcon className={"h-6 w-6"} />}
                  />
                </ChangePinModal>
              ) : activeCard.card_provider === "MM" &&
                activeCard.status === "Locked" ? (
                // MM Locked → Unblock
                <BlockUnblockCardModal
                  activeCard={activeCard}
                  contextlabel="Unblock card"
                  reasonlabel="unblock"
                  reduxAction={UnblockCard}
                >
                  <PrimaryCardButton
                    label="Unblock card"
                    icon={<UnblockCardIcon className={"h-6 w-6"} />}
                  />
                </BlockUnblockCardModal>
              ) : activeCard.card_provider === "VM" ? (
                // VM (instant or not) → Unblock
                <BlockUnblockCardModal
                  activeCard={activeCard}
                  contextlabel="Unblock card"
                  reasonlabel="unblock"
                  reduxAction={UnblockCard}
                >
                  <PrimaryCardButton
                    label="Unblock card"
                    icon={<UnblockCardIcon className={"h-6 w-6"} />}
                  />
                </BlockUnblockCardModal>
              ) : null}
            </>
          )}
        </>
      );
    default:
      return null;
  }
};

export default ButtonCardType;
